<form novalidate [formGroup]="form" (submit)="onSubmit()">
    <div class="form-group">
        <label class="form-label" for="email">{{ defaultLoginType ? 'Email:' : 'Username:' }}</label>
        <input
            #email
            type="email"
            formControlName="username"
            class="form-control"
            id="email"
            [ngClass]="{
                'is-invalid':
                    (form.controls.username.errors?.email || form.controls.username.errors?.required) && isSubmitted
            }"
        />
    </div>
    <div class="form-group">
        <label class="form-label" for="password">Password:</label>
        <input
            #password
            type="password"
            class="form-control"
            id="password"
            [ngClass]="{ 'is-invalid': form.controls.password.errors?.required && isSubmitted }"
            formControlName="password"
        />
    </div>
    <div class="login-buttons">
        <button class="btn ch-button" type="submit">log in</button>
        <div class="password-links" *ngIf="defaultLoginType">
            <a class="cm-link" [routerLink]="['/entry/forgotpw']">Forgot password</a>
        </div>
    </div>
    <cm-iframe-external-login
        [settings]="settings$ | async"
        (callback)="handleCredentialResponse($event)"
    ></cm-iframe-external-login>
</form>
<div class="error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
